import React from 'react';
import { Modal, Box, Typography, Stack, useTheme, useMediaQuery } from '@mui/material';
import CustomButton from '../CustomButton';



const CustomConfirmationModal = ({
    open,
    onClose,
    onConfirm,
    title,
    description,
    confirmText = "Confirmer",
    cancelText = "Annuler",
    showConfirm = true,
    disableConfirm = false,
    loading = false
}) => {
    const theme = useTheme();
        const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const styleModal = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // minWidth: 600,
        minWidth: isMobile ? '90vw' : 600,
        bgcolor: 'white',
        border: '1px solid white',
        borderRadius: '5px',
        boxShadow: 0,
        p: 3,
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={styleModal}>
                <Stack spacing={4}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography variant="subtitle1">{title}</Typography>
                    </Box>
                    <Box sx={{ marginTop: 2 }} dir="ltr">
                        <Typography align="center" variant="body2">{description}</Typography>
                    </Box>
                    <Stack direction="row" spacing={2} justifyContent="center">
                        <CustomButton loading={loading} type="secondaire" buttonText={cancelText} onClick={onClose} />
                        {showConfirm && (
                            <CustomButton
                                type="primaire"
                                buttonText={confirmText}
                                onClick={onConfirm}
                                disabled={disableConfirm}
                                loading={loading}
                            />
                        )}
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
};

export default CustomConfirmationModal;
